<template>
    <div class="vue-calculadora-container">
        <div class="calculadora-form-container" id="calculadora-form-container">
            <h1>Ingresa tus datos</h1>
            <form id="calculadora" name="calculadora" method="POST" @submit.prevent="validateBeforeSubmit"  enctype="multipart/form-data" autocomplete="off">
                <!-- Nombre -->
                <div class="calculadora-form-group">
                    <input type="text"
                           id="firstname"
                           name="firstname"
                           data-vv-as="Nombre"
                           v-model="firstname"
                           placeholder="Nombre:"
                           class="calculadora-form-control"
                           :class="{'has-errors': errors.has('firstname')}"
                           v-validate="'required'">
                    <FormError :attribute_name="'firstname'" :errors_form="errors"></FormError>
                </div>

                <!-- Apellido -->
                <div class="calculadora-form-group">
                    <input type="text"
                           id="lastname"
                           name="lastname"
                           data-vv-as="Apellidos"
                           v-model="lastname"
                           placeholder="Apellidos:"
                           class="calculadora-form-control"
                           :class="{'has-errors': errors.has('lastname')}"
                           v-validate="'required'">
                    <FormError :attribute_name="'lastname'" :errors_form="errors"></FormError>
                </div>

                <!-- Teléfono -->
                <div class="calculadora-form-group">
                    <input type="text"
                           id="phoneNumber"
                           name="phoneNumber"
                           data-vv-as="Teléfono"
                           v-model="phoneNumber"
                           placeholder="Teléfono:"
                           class="calculadora-form-control"
                           :class="{'has-errors': errors.has('phoneNumber')}"
                           v-validate="'required|numeric|min:9|max:9'">
                    <FormError :attribute_name="'phoneNumber'" :errors_form="errors"></FormError>
                </div>

                <!-- E-Mail -->
                <div class="calculadora-form-group">
                    <input type="email"
                           id="email"
                           name="email"
                           data-vv-as="Email"
                           v-model="email"
                           placeholder="E-Mail:"
                           class="calculadora-form-control"
                           :class="{'has-errors': errors.has('email')}"
                           v-validate="'required|email'">
                    <FormError :attribute_name="'email'" :errors_form="errors"> </FormError>
                </div>

                <!-- Sueldo Bruto -->
                <div class="calculadora-form-group">
                    <vue-numeric
                            id="sueldoBruto"
                            name="sueldoBruto"
                            v-model="sueldoBruto"
                            placeholder="Sueldo bruto:"
                            data-vv-as="Sueldo bruto"
                            separator="."
                            currency="$"
                            v-validate="'required|numeric'"
                            class="calculadora-form-control"
                            :class="{'has-errors': errors.has('sueldoBruto')}"
                            :empty-value="''"
                            output-type="String">
                    </vue-numeric>
                    <FormError :attribute_name="'sueldoBruto'" :errors_form="errors"> </FormError>
                </div>

                <!-- Periodo Trabajado -->
                <!--start date-->
                <div class="calculadora-form-group">
                    <VueCtkDateTimePicker
                            v-model="startDate"
                            :formatted="'DD-MM-YYYY'"
                            :format="'YYYY-MM-DD'"
                            :only-date="true"
                            :max-date="this.fechaActual"
                            :button-now-translation="'Hoy'"
                            :color="'#c4161c'"
                            :button-color="'#1425b1'"
                            :no-value-to-custom-elem="true"
                            :no-button="true"
                            :auto-close="true"
                    >
                        <input
                                type="text"
                                id="startDateMasked"
                                name="startDateMasked"
                                v-model="startDateMasked"
                                placeholder="Inicio periodo trabajo:"
                                data-vv-as="Inicio periodo trabajo"
                                class="calculadora-form-control"
                                :class="{'has-errors': errors.has('startDateMasked')}"
                                v-validate="'required'"
                        />
                    </VueCtkDateTimePicker>
                    <FormError :attribute_name="'startDateMasked'" :errors_form="errors"> </FormError>
                </div>
                <!--end date-->
                <div class="calculadora-form-group">
                    <VueCtkDateTimePicker
                            v-model="endDate"
                            :formatted="'DD-MM-YYYY'"
                            :format="'YYYY-MM-DD'"
                            :only-date="true"
                            :max-date="this.fechaActual"
                            :min-date="this.startDate"
                            :button-now-translation="'Hoy'"
                            :color="'#c4161c'"
                            :button-color="'#1425b1'"
                            :no-value-to-custom-elem="true"
                            :no-button="true"
                            :auto-close="true"
                    >
                        <input
                                type="text"
                                id="endDateMasked"
                                name="endDateMasked"
                                v-model="endDateMasked"
                                placeholder="Fin periodo trabajo:"
                                data-vv-as="Fin periodo trabajo"
                                v-validate="'required'"
                                class="calculadora-form-control"
                                :class="{'has-errors': errors.has('endDateMasked')}"
                        >
                    </VueCtkDateTimePicker>
                    <FormError :attribute_name="'endDateMasked'" :errors_form="errors"> </FormError>
                </div>

                <div class="grid-container">
                    <transition
                            enter-to-class="animated zoomIn"
                            leave-to-class="animated fadeOut"
                    >
                        <div class="grid-item" v-if="isVerified == true">
                            <button type="submit" id="btnCalcular">
                                Calcular <img class="icon-btn" src="../assets/images/calc_calculator_10824.png"/>
                            </button>
                        </div>
                    </transition>

                    <transition
                            enter-to-class="animated fadeIn"
                            leave-to-class="animated fadeOut">
                        <div id="calcularSpinner" v-if="showCalcularSpinner == true">
                            <hour-glass ></hour-glass>
                        </div>
                    </transition>
                </div>
            </form>
        </div>
        <div class="calculadora-response-container" id="calculadora-response-container">
            <transition
                    enter-to-class="animated zoomIn"
                    leave-to-class="animated fadeOut"
            >
                <div id="helpOnFail" v-if="showHelpOnFail == true">
                    <div id="helpOnFailText">¡Ha ocurrido un error! <br>Por favor verifica que tu navegador este actualizado o usas un navegador compatible.</div>
                    <div class="browser-links-container">
                        <a href="https://www.mozilla.org/es-CL/firefox/new/" target="_blank"><img src="../assets/images/firefox.png"/></a>
                        <a href="https://www.google.com/chrome/" target="_blank"><img src="../assets/images/chrome.png"/></a>
                        <a href="https://www.opera.com/" target="_blank"><img src="../assets/images/opera.png"/></a>
                        <a href="https://support.apple.com/downloads/safari" target="_blank"><img src="../assets/images/safari.png"/></a>
                        <a href="https://www.microsoft.com/es-cl/windows/microsoft-edge" target="_blank"><img src="../assets/images/edge.png"/></a>
                    </div>
                </div>
            </transition>

            <transition
                    enter-to-class="animated zoomIn"
                    leave-to-class="animated fadeOut"
            >
                <div id="detalleDeuda" v-if="showRespuesta == true">
                    <h1>Tu indemnización <img class="icon-lawyer" src="../assets/images/lawyer_86193.png"/></h1>
                    <div id="resultado">
                        <div class="row">
                            <div class="column_title">Periodo trabajado</div>
                            <div class="column_value">{{ periodoTrabajado }}</div>
                        </div>
                        <div class="row">
                            <div><h3>Indemnización proyectada</h3></div>
                        </div>
                        <div class="row">
                            <div class="column_title">Indemnización por años de servicio</div>
                            <div class="column_value">{{ indemnizacionAñosServicio | currency }}</div>
                        </div>
                        <div class="row">
                            <div class="column_title">Recargo legal del 50%</div>
                            <div class="column_value">{{ recargoIndemnizacionAñosServicio | currency }}</div>
                        </div>
                        <div class="row">
                            <div class="column_title">Indemnización sustitutiva de aviso</div>
                            <div class="column_value">{{ indemnizacionSustitutiva | currency }}</div>
                        </div>
                        <div class="row">
                            <div class="column_title">Vacaciones proporcionales</div>
                            <div class="column_value">{{ vacacionesProporcionales | currency }}</div>
                        </div>
                        <div class="row">
                            <div class="column_title"><b>Total indemnización</b></div>
                            <div class="column_value">{{ totalIndemnizacion | currency }}</div>
                        </div>
                        <div class="row">
                            <div class="column_title">Nulidad del despido por 12 meses</div>
                            <div class="column_value">{{ leyBustos | currency }}</div>
                        </div>
                        <div class="row" style="color: #55c524">
                            <div class="column_title"><b>Total a pagar al finalizar juicio</b></div>
                            <div class="column_value">{{ totalFinalJuicio | currency }}</div>
                        </div>
                        <div class="row">
                            <div><h3>Cotizaciones con multas, intereses y recargos</h3></div>
                        </div>
                        <div class="row">
                            <div class="column_title">AFP (10%)</div>
                            <div class="column_value">{{ deudaAFP | currency }}</div>
                        </div>
                        <div class="row">
                            <div class="column_title">Fondo de Cesantía (AFC)</div>
                            <div class="column_value">{{ deudaAFC | currency }}</div>
                        </div>
                        <div class="row">
                            <div class="column_title">FONASA o ISAPRE (7%)</div>
                            <div class="column_value">{{ deudaSalud | currency }}</div>
                        </div>
                    </div>
                    <transition
                        enter-to-class="animated fadeIn"
                        leave-to-class="animated fadeOut">
                        <div id="sendingMessageSpinner" v-if="showLoading == true">
                            <mike-pad></mike-pad>
                        </div>
                    </transition>
                    <transition
                            enter-to-class="animated zoomIn"
                            leave-to-class="animated fadeOut">
                        <div id="sendMessageSuccess" class="grid-container" v-if="showSendMessageSuccess == true">
                            <img class="icon-success" src="../assets/images/emblemdefault_103756.png"/>
                            <span>&#161;Sus datos han sido ingresados, pronto lo contactaremos&#33;</span>
                        </div>
                    </transition>
                    <!-- <a href="" v-on:click.prevent="solicitarAsesoriaClicked" class="btn-solicitud-asesoria">
                        Solicita Asesoría <b>GRATIS</b> <img class="icon-btn" src="../assets/images/read_email_icon-icons.com_65792.png"/>
                    </a> -->
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { VueReCaptcha } from 'vue-recaptcha-v3';
    import FormError from './FormError';
    import es from 'vee-validate/dist/locale/es';
    import VeeValidate , { Validator } from 'vee-validate';
    import VueCurrencyFilter from 'vue-currency-filter';
    import VueNumeric from 'vue-numeric'
    import {scroller} from 'vue-scrollto/src/scrollTo';
    import {MikePad,HourGlass} from 'vue-loading-spinner';
    import moment from 'moment'
    import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
    import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';
    

    Vue.use(VueReCaptcha, { 
        siteKey: "6Lenre4ZAAAAAEM4kXnQNzzfcpDww-sYOyeRP8_u",
        loaderOptions: {
            useRecaptchaNet: false,
            autoHideBadge: false,
            renderParameters: {},
            explicitRenderParameters: {  badge: 'bottomleft',}
        }
    });

    moment.locale('es');
    Vue.component('VueCtkDateTimePicker', VueCtkDateTimePicker);

    const scrollTo = scroller();
    const axios = require('axios');

    Vue.use(VueCurrencyFilter, {
            symbol : '$',
            thousandsSeparator: '.',
            fractionCount: 0,
            fractionSeparator: ',',
            symbolPosition: 'front',
            symbolSpacing: true,
    });

    Vue.use(VeeValidate);
    Validator.localize('es', es);

    export default {
        name: 'CalculadoraForm',
        components: {
            FormError,
            VueNumeric,
            MikePad,
            HourGlass
        },
        data() {
            return {
                showCalcularSpinner: false,
                showHelpOnFail: false,
                isRequiredDate: true,
                popoverVisivility: 'focus',
                fechaActual: moment().format('YYYY-MM-DD'),
                isVerified: true,
                theme: 'Dark',
                sitekey: '6LeEi4wUAAAAAGCH-f6Q7fKcKss7hiAr7tlKHn-D',
                periodoTrabajado:0,
                deudaAFP: 0,
                deudaAFC: 0,
                deudaSalud: 0,
                indemnizacionAñosServicio: 0,
                recargoIndemnizacionAñosServicio: 0,
                indemnizacionSustitutiva: 0,
                vacacionesProporcionales: 0,
                totalIndemnizacion: 0,
                leyBustos: 0,
                totalFinalJuicio: 0,
                info: null,
                startDate:'',
                startDateMasked:'',
                startDateSA:'',
                endDate:'',
                endDateMasked:'',
                endDateSA:'',
                firstname: "",
                firstnameSA: "",
                lastname: "",
                lastnameSA: "",
                phoneNumber: "",
                phoneNumberSA: "",
                email: "",
                emailSA: "",
                sueldoBruto: "",
                sueldoBrutoSA: "",
                periodoTrabajo: "",
                showLoading: false,
                showRespuesta: false,
                showSendMessageSuccess: false,
                msgErrorDate: '',
                selectedDay: null,
            };
        },
        methods: {
            validateBeforeSubmit: function() {
                this.$validator.validateAll().then(async (result) => {
                    if (result) {
                        // pedir token reCAPTCHA antes de enviar
                        await this.$recaptchaLoaded()
                        const token = await this.$recaptcha('submit');

                        this.showCalcularSpinner = true;
                        this.showRespuesta = false;
                        this.msgErrorDate = '';
                        this.showSendMessageSuccess = false;
                        this.firstnameSA = this.firstname;
                        this.lastnameSA = this.lastname;
                        this.phoneNumberSA = this.phoneNumber;
                        this.emailSA = this.email;
                        this.sueldoBrutoSA = this.sueldoBruto;
                        this.startDateSA = this.startDate;
                        this.endDateSA = this.endDate;
                        this.showHelpOnFail = false;
                        //PROCESAR Y MOSTRAR DETALLE DEL CALCULO
                        //CONSUMIR LA API DE DEFENSA HONORARIOS
                        axios.get('https://www.backend-calculadora.defensahonorarios.cl/api/calculadora', {
                            params: {
                                sueldoBruto: this.sueldoBruto,
                                startDate: this.startDate,
                                endDate: this.endDate,
                                recaptcha_token: token
                            }
                        })
                        .then(response => {
                            this.periodoTrabajado = response.data.periodoTrabajado;
                            this.indemnizacionAñosServicio = response.data.indemnizacionAñosServicio;
                            this.recargoIndemnizacionAñosServicio = response.data.recargoIndemnizacionAñosServicio;
                            this.indemnizacionSustitutiva = response.data.indemnizacionSustitutiva;
                            this.vacacionesProporcionales = response.data.vacacionesProporcionales;
                            this.totalIndemnizacion = response.data.totalIndemnizacion;
                            this.totalFinalJuicio = response.data.totalFinalJuicio;
                            this.leyBustos = response.data.leyBustos;
                            this.deudaAFP = response.data.afp;
                            this.deudaAFC = response.data.afc;
                            this.deudaSalud = response.data.salud;
                            this.showRespuesta=true;
                            this.$logger.saveToLog('calculadora_error_logs.txt', 'hello log...');
                        })
                        .catch(error => {
                            // eslint-disable-next-line
                            console.debug(error);
                            this.$logger.saveToLog('calculadora_error_logs.txt', error);
                            this.showHelpOnFail = true;
                        })
                        .finally(() => {
                            this.showCalcularSpinner = false;
                            scrollTo('#calculadora-response-container');
                            this.solicitarAsesoriaClicked(token);
                        });
                        return;
                    }
                });
            },
            solicitarAsesoriaClicked: function(token) {
                this.showSendMessageSuccess=false;
                axios.post('https://www.backend-calculadora.defensahonorarios.cl/api/solicitudAsesoria', {
                    email: this.emailSA,
                    nombre: this.firstnameSA,
                    apellidos: this.lastnameSA,
                    sueldoBruto: this.sueldoBrutoSA,
                    startDate: this.startDateSA,
                    endDate: this.endDateSA,
                    telefono: this.phoneNumberSA,
                    periodoTrabajado: this.periodoTrabajado,
                    indemnizacionAñosServicio: this.indemnizacionAñosServicio,
                    recargoIndemnizacionAñosServicio: this.recargoIndemnizacionAñosServicio,
                    indemnizacionSustitutiva: this.indemnizacionSustitutiva,
                    vacacionesProporcionales: this.vacacionesProporcionales,
                    totalIndemnizacion: this.totalIndemnizacion,
                    totalFinalJuicio: this.totalFinalJuicio,
                    leyBustos: this.leyBustos,
                    deudaAFP: this.deudaAFP,
                    deudaAFC: this.deudaAFC,
                    deudaSalud: this.deudaSalud,
                    token: token
                }).then(response => {
                    this.showLoading=true;
                    axios.post('https://www.backend-calculadora.defensahonorarios.cl/api/enviarMailSolicitarAsesoria', {
                        id: response.data,
                        token: token
                    }).then(response => {
                        // eslint-disable-next-line
                        var e = response;
                    }).catch(error => {
                        // eslint-disable-next-line
                        var e = error;
                    }).finally(() => {
                        this.showLoading=false;
                        this.showSendMessageSuccess = true
                    });
                }).catch(error => {
                    // eslint-disable-next-line
                    var e = error;
                })
                return;
            },
            dayClicked(day) {
                this.selectedDay = day;
            }
        },
        watch: {
            sueldoBruto: function (val) {
                if(val == 0) {
                    this.sueldoBruto = '';
                }
            },
            startDate: function(val) {
                this.startDateMasked = moment(val).format('DD-MMMM-YYYY');
            },
            endDate: function(val) {
                this.endDateMasked = moment(val).format('DD-MMMM-YYYY');
            },
        },
    }
</script>

<style>
    @import '../assets/css/animate.css';
    @import '../assets/css/vue-calculadora.css';
    @import '../assets/css/vue-airbnb-style-datepicker.css';
</style>
